import React from "react";
import { Sparkles, Target, Telescope } from "lucide-react";

const VALUES = ["Intégrité", "Excellence", "Innovation", "Collaboration", "Impact"];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#0A1326] text-[#F5F5F5] py-20 md:py-32 grain overflow-hidden border-t border-[#D4AF37]/10"
    >
      <div className="absolute inset-0 peul-pattern opacity-40 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-5 md:px-8 lg:px-12">
        {/* Header */}
        <div className="max-w-3xl">
          <div className="overline text-[#D4AF37]">── À propos</div>
          <h2 className="font-display text-[32px] sm:text-4xl md:text-5xl lg:text-6xl font-black tracking-tight mt-4 leading-[1.05]">
            Une intelligence stratégique enracinée en{" "}
            <span className="text-[#D4AF37]">Afrique</span>.
          </h2>
        </div>

        {/* Inspiration / Mission / Vision */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-5 mt-10 md:mt-14">
          {/* Inspiration */}
          <div
            data-testid="about-inspiration"
            className="hk-card relative border border-[#D4AF37]/20 bg-[#142042]/60 p-8 rounded-[2px]"
          >
            <Sparkles size={24} className="text-[#D4AF37]" strokeWidth={1.6} />
            <div className="overline text-[#D4AF37] mt-6">Inspiration</div>
            <h3 className="font-display text-2xl font-bold mt-3">
              Le sens d'<span className="italic">Hakkilo</span>
            </h3>
            <p className="mt-4 text-[#F5F5F5]/70 text-[15px] leading-relaxed">
              Du mot peul <em className="text-[#D4AF37] not-italic font-semibold">« Hakkilo »</em>{" "}
              qui signifie <strong>intelligence, réflexion, stratégie</strong>.
              Notre symbole s'inspire des racines peules, du leadership et de
              la connexion entre les peuples.
            </p>
          </div>

          {/* Mission */}
          <div
            data-testid="about-mission"
            className="hk-card relative border border-[#D4AF37]/20 bg-[#142042]/60 p-8 rounded-[2px]"
          >
            <Target size={24} className="text-[#D4AF37]" strokeWidth={1.6} />
            <div className="overline text-[#D4AF37] mt-6">Notre mission</div>
            <h3 className="font-display text-2xl font-bold mt-3">
              Bâtir la confiance digitale africaine
            </h3>
            <p className="mt-4 text-[#F5F5F5]/70 text-[15px] leading-relaxed">
              Fournir des solutions technologiques innovantes et sécurisées
              pour accompagner la transformation digitale de l'Afrique et du
              monde.
            </p>
          </div>

          {/* Vision */}
          <div
            data-testid="about-vision"
            className="hk-card relative border border-[#D4AF37]/20 bg-[#142042]/60 p-8 rounded-[2px]"
          >
            <Telescope size={24} className="text-[#D4AF37]" strokeWidth={1.6} />
            <div className="overline text-[#D4AF37] mt-6">Notre vision</div>
            <h3 className="font-display text-2xl font-bold mt-3">
              Africa Rooted. Global Minded.
            </h3>
            <p className="mt-4 text-[#F5F5F5]/70 text-[15px] leading-relaxed">
              Devenir le partenaire technologique de référence, enraciné en
              Afrique, reconnu dans le monde.
            </p>
          </div>
        </div>

        {/* VALUES band */}
        <div className="mt-16 border-t border-[#D4AF37]/15 pt-10">
          <div className="flex flex-col md:flex-row md:items-center gap-6 md:gap-10">
            <div className="overline text-[#D4AF37] shrink-0">── Nos valeurs</div>
            <div className="flex flex-wrap gap-2 md:gap-3">
              {VALUES.map((v) => (
                <span
                  key={v}
                  data-testid={`value-${v.toLowerCase()}`}
                  className="inline-flex items-center px-4 py-2 border border-[#D4AF37]/30 text-[#F5F5F5] font-display font-semibold text-sm tracking-wide rounded-[2px] hover:bg-[#D4AF37] hover:text-[#0A1326] transition-colors cursor-default"
                >
                  {v}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
